import React from "react";
import {Button, Container} from "react-bootstrap";

import {AdminAddLead} from "../Components/AdminLeads/AdminAddLead";
import {Row, Col, Card} from "react-bootstrap";
import {AdminAddCompany} from "../Components/AdminCompany/AdminAddCompany";
import {AdminAddUserComponent} from "../Components/AdminUsers/AdminAddUserComponent";
import {AdminAddServices} from "../../services/AdminAddServices";

export const AdminOnboardDashboard = () => {


    return (
        <Container fluid={"xl"}>


            <Row>
                <Col>
                    <Card>
                        <h4>
                            Leadtubs admin-dashboard
                        </h4>
                        <hr/>
                        <p>
                            Lägg till användare, företag och leads.
                        </p>

                    </Card>
                </Col>

            </Row>

            <Row>
                <Col>
                    <AdminAddCompany/>

                </Col>
                <Col>
                    <AdminAddServices/>
                </Col>
                <Col>
                    <AdminAddUserComponent/>
                </Col>

                <Col>
                    <AdminAddLead/>
                </Col>

            </Row>
        </Container>
    )
}
